import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import PoliticaPrivacidad from './pages/PoliticaPrivacidad';
import Cookies from './pages/Cookies';
import AvisoLegal from './pages/AvisoLegal';
import TerminosCondiciones from './pages/TerminosCondiciones';
import ClausulasConsentimiento from './pages/ClausulasConsentimiento';
import AnalisisDatos from './pages/AnalisisDatos';
import Logistica from './pages/Logistica';
import AtencionCliente from './pages/AtencionCliente';
import Organizacion from './pages/Organizacion';
import SolucionesPersonalizadas from './pages/SolucionesPersonalizadas';
import NosotrosPage from "./pages/NosotrosPage";
import Blog from './pages/Blogs';
import QueEsAgenteIA from './pages/blogs/que-es-agente-ia';
import DespliegueRapidoN8N from "./pages/blogs/despliegue-rapido-n8n";
import EstrategiaAutomatizacion from "./pages/blogs/estrategia-automatizacion";
import FuturoIAIndustrial from "./pages/blogs/futuro-industrial";
import ClawdbotAnalisis from "./pages/blogs/ClawbotAnalisis";
import AliadoInvisible from "./pages/blogs/AliadoInvisible";
import IaLocalizada from "./pages/blogs/IaLocalizada";
import MantenimientoPredictivo from './pages/portofolio/MantenimientoPredictivo';
import OrquestadorMultiAgente from './pages/portofolio/OrquestadorMultiAgente';
import CerebroDocumental from './pages/portofolio/CerebroDocumental';
import ConectividadLegacy from './pages/portofolio/ConectividadLegacy';
import ImpactoClaudeCode from "./pages/blogs/ImpactoClaudeCode";
import DemoInmobiliaria from './pages/demos/DemoInmobiliaria';
import ScrollToTop from './ScrollToTop';
function App() {
    return (
        <HelmetProvider>
            <Router>
                <ScrollToTop/>
                <div className="app-container">
                    <Header/>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/politicadeprivacidad" element={<PoliticaPrivacidad />} />
                        <Route path="/cookies" element={<Cookies />} />
                        <Route path="/avisolegal" element={<AvisoLegal />} />
                        <Route path="/terminosycondiciones" element={<TerminosCondiciones />} />
                        <Route path="/clausulasdeconsentimiento" element={<ClausulasConsentimiento />} />
                        <Route path="/analisisdedatos" element={<AnalisisDatos/>} />
                        <Route path="/logistica" element={<Logistica />} />
                        <Route path="/atencioncliente" element={<AtencionCliente />} />
                        <Route path="/organizacion" element={<Organizacion />} />
                        <Route path="/solucionespersonalizadas" element={<SolucionesPersonalizadas />} />
                        <Route path="/nosotros" element={<NosotrosPage />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blogs/que-es-agente-ia" element={<QueEsAgenteIA />} />
                        <Route path="/blogs/despliegue-rapido-n8n" element={<DespliegueRapidoN8N />} />
                        <Route path="/blogs/estrategia-automatizacion" element={<EstrategiaAutomatizacion />} />
                        <Route path="/blogs/futuro-industrial" element={<FuturoIAIndustrial />} />
                        <Route path="/blogs/ClawbotAnalisis" element={<ClawdbotAnalisis />}/>
                        <Route path="/blogs/AliadoInvisible" element={<AliadoInvisible />}/>
                        <Route path="/blogs/IaLocalizada" element={<IaLocalizada/>}/>
                        <Route path="/blogs/ImpactoClaudeCode" element={<ImpactoClaudeCode/>}/>
                        <Route path="/portfolio/mantenimiento-predictivo" element={<MantenimientoPredictivo />} />
                        <Route path="/portfolio/orquestador-multi-agente" element={<OrquestadorMultiAgente />} />
                        <Route path="/portfolio/cerebro-documental" element={<CerebroDocumental />} />
                        <Route path="/portfolio/conectividad-legacy" element={<ConectividadLegacy />} />
                        <Route path="/demos/inmobiliarias" element={<DemoInmobiliaria />} />
                    </Routes>

                    <Footer />
                </div>
            </Router>
        </HelmetProvider>
    );
}

export default App;